import { useEffect, useRef, useState } from "react";
import { animate, useInView } from "framer-motion";

export const CountUp = ({ to, decimals = 0, duration = 1.8 }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.15 });
  const [val, setVal] = useState(0);
  useEffect(() => {
    if (!inView) return undefined;
    const controls = animate(0, to, { duration, ease: [0.22, 1, 0.36, 1], onUpdate: setVal });
    return () => controls.stop();
  }, [inView, to, duration]);
  return <span ref={ref} className="tabular-nums" aria-label={to.toFixed(decimals)}>{val.toFixed(decimals)}</span>;
};
